import React from 'react';

const ContactUs = () => {
    return (
        <div className="contact-us-section">
            <h1><strong>Contact Us</strong></h1>
            <p>If you have any questions, need any assistance or maybe even give us some feedback to improve, feel free to reach out to us through the information below or use the contact form.</p>

            <div className="contact-details">
                <p>
                    <i className="fas fa-envelope"></i> 
                    <strong>E-mail:&nbsp;</strong> 
                    <a href="mailto:digitalwardrobe@info.com"> digitalwardrobe@info.com</a>
                </p>
                <p>
                    <i className="fas fa-phone"></i> 
                    <strong>Phone Number:&nbsp;</strong> 
                    <a href="tel:+306984483349"> +30 698 448 3349</a>
                </p>
            </div>

            <div className="social-links">
                <a href="https://www.facebook.com/profile.php?id=100013363719227" aria-label="Facebook"><i className="fab fa-facebook-f fa-spin"></i></a>
                <a href="https://x.com/p2019034" aria-label="Twitter"><i class="fa-brands fa-x-twitter fa-spin"></i></a>
                <a href="https://www.instagram.com/j.totheother.j" aria-label="Instagram"><i className="fab fa-instagram fa-spin"></i></a>
            </div>

            <form className="contact-form">
                <div className="form-group">
                    <label><strong>Full Name</strong>*</label>
                    <input type="text" placeholder="Your full name" required />
                </div>
                <div className="form-group">
                    <label><strong>E-mail</strong>*</label>
                    <input type="email" placeholder="Your email" required />
                </div>
                <div className="form-group">
                    <label><strong>Subject</strong>*</label>
                    <input type="text" placeholder="Subject of message" required />
                </div>
                <div className="form-group">
                    <label><strong>Message</strong>*</label>
                    <textarea placeholder="Your message" required></textarea>
                </div>
                <button type="submit" className="send-button"><strong>SEND</strong></button>
            </form>
        </div>
    );
};

export default ContactUs;